import { DriversLicenseColor } from "Const"

const VALID_EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/
const CHARACTER_LIMIT_REGEX = /^(?=.*).{7,10}$/
const NUMBER_AND_ALPHABET_REGEX = /^(?=.*?[a-zA-Z])(?=.*?\d)[a-zA-Z\d]/
const NUMBER_OR_ALPHABET_REGEX = /^[0-9a-zA-Z]+$/
// 未入力判定(汎用)
export const isEmpty = (obj: string | number) => {
  return obj === "" || obj === null || obj === undefined || obj === "-1" || obj === -1
}
// メールアドレスフォーマット判定
export const isNotEmailFormat = (email: string) => {
  return !VALID_EMAIL_REGEX.test(email)
}
// 型式の先頭文字ハイフン判定
export const hyphenIsAtBeginning = (model: string) => {
  return model.charAt(0) === "-"
}
// 未使用
export const isIneligibleCarType = (type: string) => {
  // TODO バリデーション内容を要実装（APIレスポンスから直接判定可能であれば不要）
  return true
}
// 年齢判定(20歳以下)
export const isUnder20 = (age: number) => {
  return age < 21
}
// 取得免許可能年齢判定(ゴールド)
export const isWrongCertificateColor = (age: number, color: number) => {
  return age < 21 && color === DriversLicenseColor.Gold
}
// 未使用
export const registrationDateIsAfterCompensationStart = (registDate: string, compStart: string) => {
  const regist = new Date(registDate)
  const comp = new Date(compStart)
  return regist > comp
}
// 同一文字判定(メール入力)
export const isNotSame = (x: string, y: string) => {
  return x !== y
}
// 入力文字数制限の判定(パスワード入力)
export const isNotCharacterLimit = (password: string) => {
  return !CHARACTER_LIMIT_REGEX.test(password)
}
// 入力可能文字＆組み合わせ判定(パスワード入力)
export const isNotNumberAlphabet = (password: string) => {
  return !(NUMBER_AND_ALPHABET_REGEX.test(password) && NUMBER_OR_ALPHABET_REGEX.test(password))
}
// 同一文字判定(メール入力≠パスワード入力)
export const isSameEmailId = (email: string, password: string) => {
  const emailId = email.split("@")
  return emailId[0] === password
}
